import { getStripePurchaseCommonEventParams } from 'modules/purchase/helpers/getStripePurchaseCommonEventParams'

import { IAppState } from 'models/store.model'

export const getStripePurchaseStartedEventParams = (state: IAppState) => {
  const {
    productId,
    trialPeriodPrice,
    stripePriceId,
    currency,
    screenName,
    stripeAccountName,
    fullPrice,
    trialPriceId,
    stripeAccountId,
  } = getStripePurchaseCommonEventParams(state)

  return {
    productId: trialPriceId ? productId : stripePriceId,
    priceDetails: {
      price: fullPrice,
      trial: !!trialPeriodPrice,
      currency,
    },
    screenName,
    stripeAccountName,
    stripeAccountId,
  }
}
